import { render, staticRenderFns } from "./Header2.vue?vue&type=template&id=f8f59432"
import script from "./Header2.vue?vue&type=script&lang=js"
export * from "./Header2.vue?vue&type=script&lang=js"
import style0 from "./Header2.vue?vue&type=style&index=0&id=f8f59432&prod&lang=scss"
import style1 from "./Header2.vue?vue&type=style&index=1&id=f8f59432&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports